export var Size = /*#__PURE__*/ function(Size) {
    Size["xs"] = "xs";
    Size["s"] = "s";
    Size["m"] = "m";
    Size["l"] = "l";
    return Size;
}({});
export var Variant = /*#__PURE__*/ function(Variant) {
    Variant["pillLight"] = "pillLight";
    Variant["pillOutline"] = "pillOutline";
    Variant["pillDark"] = "pillDark";
    Variant["badgeColor"] = "badgeColor";
    Variant["badgeModern"] = "badgeModern";
    return Variant;
}({});
//? BadgeGroup _________________________________________________________
export var BadgePlacement = /*#__PURE__*/ function(BadgePlacement) {
    BadgePlacement["left"] = "left";
    BadgePlacement["right"] = "right";
    return BadgePlacement;
}({});
export var BadgeGroupSize = /*#__PURE__*/ function(BadgeGroupSize) {
    BadgeGroupSize["m"] = "m";
    BadgeGroupSize["l"] = "l";
    return BadgeGroupSize;
}({});
